module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/publication-review-view/publication-review-view.component.scss
// module id = ./src/app/+app-custom/views/publication-review-view/publication-review-view.component.scss
// module chunks = main